namespace Matrix.Data {
    export interface ListRow {
        ListCode?: string;
        ListName?: string;
        ListType?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace ListRow {
        export const idProperty = 'ListCode';
        export const nameProperty = 'ListName';
        export const localTextPrefix = 'Data.List';
        export const lookupKey = 'Data.List';

        export function getLookup(): Q.Lookup<ListRow> {
            return Q.getLookup<ListRow>('Data.List');
        }
        export const deletePermission = 'DataAdmin:List';
        export const insertPermission = 'DataAdmin:List';
        export const readPermission = 'Read:List';
        export const updatePermission = 'DataAdmin:List';

        export declare const enum Fields {
            ListCode = "ListCode",
            ListName = "ListName",
            ListType = "ListType",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
